export const loaderHandler = (action) => {
    if (!action) {
        throw Error('"setDisabledButton function - "You didn\'t add required parameters');
    }
    const loader = document.querySelector('.js-accessible-docs-admin-loader');
    if (loader) {
        loader.classList[action]('active');
    }
};
export const setDisabledButton = (selector, disabled) => {
    if (!selector) {
        throw Error('"setDisabledButton function - "You didn\'t add required parameters');
    }
    const button = document.querySelector(selector);
    if (button) {
        button.disabled = disabled;
    }
};
export const returnCheckedDocumentsIds = () => {
    const checkboxes = document.querySelectorAll('.js-accessible-docs-id');
    if (checkboxes.length > 0) {
        const checkedValues = Array.from(checkboxes)
            .filter(checkbox => checkbox.checked)
            .map(checkbox => checkbox.value);
        return checkedValues.length ? checkedValues : false;
    }
    return false;
};
export const showErrorAlert = (errorText) => {
    loaderHandler('remove');
    if (errorText) {
        alert(errorText);
    }
};
